import React from 'react';
import styled from 'styled-components/macro';

import Somersby, { Wrapper as _Somersby } from '../../common/components/svg/Somersby';

const Wrapper = styled.div`
  position: relative;
  height: 200rem;

  ${_Somersby} {
    position: absolute;
    height: 100%;
    width: auto;

    transform: translateX(-50%);
  }
`;

const Tree = ({ progress }: { progress: number }) => (
  <Wrapper>
    <Somersby percentageFull={100} fill="#ffffff33" />
    <Somersby percentageFull={progress} fill="white" />
  </Wrapper>
);

export default Tree;